import { BaseMessage } from '../messages/baseMessage';

export interface IBaseCommand {
    get message(): BaseMessage;
    process(message: BaseMessage);
}

type INoParamConstructor<T> = new (...args: any[]) => T;

export class BaseCommand<T extends BaseMessage> implements IBaseCommand {
    private _message: T;
    get message(): T {
        return this._message;
    }
    constructor(private messageTypeCtor: INoParamConstructor<T>) {
        this._message = new messageTypeCtor();
    }

    public process() {
        if (this.verifyMessage(this.message)) {
            const castedMessage = <T>this.message;
            this.doProcess(castedMessage);
        }
    }

    protected doProcess(message: T) {
    }

    // Verify that the message is of the right type and that it has been deserialized from data
    private verifyMessage(value: BaseMessage): boolean {
        return this.message.command !== null && this.message.command !== undefined && value instanceof this.messageTypeCtor;
    }
}
